import { Component, Input } from "@angular/core";
import { CardState, PerfTableColumn } from "../card-types";

@Component({
  selector: "table-panel",
  templateUrl: "./table-panel.component.html",
  styleUrls: ["../../dashboard-section.scss", "../../dashboard-section-v2.scss"],
  styles: [":host { display: block; flex: 1; min-width: 0; }"],
})
export class TablePanelComponent {
  @Input() title: string;
  @Input() hint: string;
  @Input() state: CardState<any>;
  @Input() nameColumn: PerfTableColumn;
  @Input() valueColumns: PerfTableColumn[] = [];
  @Input() isReport: boolean = false;
}
